import { useHistory } from 'react-router-dom';
import useConfig from 'client/hooks/useConfig';
import { useEffect, useState } from 'react'
import url from 'client/utils/url';

export default function useCurrentOption() {
  const history = useHistory();
  const qsParams = useConfig();
  const [currentOption, setCurrentOption] = useState('');

  const initCurrentOption = qsParams.CURRENT_OPTION;

  const handleCurrentOptionChanged = (optionCode: string) => {
    setCurrentOption(optionCode);
  }

  useEffect(() => {
    if(initCurrentOption){
      setCurrentOption(initCurrentOption);
      const newUrl = url.getPageNavigationV3('options', {
        ...qsParams,
        CURRENT_OPTION: undefined,
      });
      history.replace(newUrl);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initCurrentOption])

  return { currentOption, handleCurrentOptionChanged };
}